import { Badge } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { RegisterMessages } from "@/messages/register/register.messages";

import {
  ChangePasswordDescription,
  ChangePasswordTitle,
  PasswordRequirements,
  PasswordRequirementsContainer,
} from "../styles";

type Props = {
  messages: RegisterMessages;
  hasSpecialCharacter: boolean;
  hasLowerCase: boolean;
  hasUpperCase: boolean;
  hasNumber: boolean;
  hasMinCharacters: boolean;
};

function PasswordRequirementsSection({
  messages,
  hasSpecialCharacter,
  hasLowerCase,
  hasUpperCase,
  hasNumber,
  hasMinCharacters,
}: Props) {
  return (
    <Grid size={12}>
      <ChangePasswordTitle sx={{ color: "white !important" }}>
        {messages.changePasswordRequirements}
      </ChangePasswordTitle>
      <ChangePasswordDescription sx={{ color: "white !important" }}>
        {messages.changePasswordRequirementsDescription}
      </ChangePasswordDescription>
      <PasswordRequirementsContainer>
        <Badge color={hasSpecialCharacter ? "success" : "warning"} variant="dot" />
        <PasswordRequirements sx={{ color: "white !important" }}>
          {messages.changePasswordSpecialCharacterRule}
        </PasswordRequirements>
      </PasswordRequirementsContainer>
      <PasswordRequirementsContainer>
        <Badge color={hasLowerCase ? "success" : "warning"} variant="dot" />
        <PasswordRequirements sx={{ color: "white !important" }}>
          {messages.changePasswordLowerRule}
        </PasswordRequirements>
      </PasswordRequirementsContainer>
      <PasswordRequirementsContainer>
        <Badge color={hasUpperCase ? "success" : "warning"} variant="dot" />
        <PasswordRequirements sx={{ color: "white !important" }}>
          {messages.changePasswordUpperRule}
        </PasswordRequirements>
      </PasswordRequirementsContainer>
      <PasswordRequirementsContainer>
        <Badge color={hasNumber ? "success" : "warning"} variant="dot" />
        <PasswordRequirements sx={{ color: "white !important" }}>
          {messages.changePasswordOneNumberRule}
        </PasswordRequirements>
      </PasswordRequirementsContainer>
      <PasswordRequirementsContainer>
        <Badge color={hasMinCharacters ? "success" : "warning"} variant="dot" />
        <PasswordRequirements sx={{ color: "white !important" }}>
          {messages.changePasswordMinRule}
        </PasswordRequirements>
      </PasswordRequirementsContainer>
    </Grid>
  );
}

export default PasswordRequirementsSection;
